import React, { useState, useEffect, useContext } from "react";
import { fetchedWarehousesBySubsidiary } from "../../../apis/apis.logistics/apisProduct";
import { queryDocumentReniec } from "../../../apis/apis.logistics/apisSunat";
import { toast } from "react-toastify";
import { ContextAuth } from "../../../contexts/ContextAuth";

import {
  personDocumentTypes,
  operationDocumentTypes,
} from "../../../configs/Data";

export function ConcludeOrderPurchaseForm({ order, setOrder }) {
    
  const { auth } = useContext(ContextAuth);
  const [warehouses, setWarehouses] = useState([]);
  const getWarehouses = async (id) => {
    try {
      const response = await fetchedWarehousesBySubsidiary({
        subsidiaryID: id,
      });
      setWarehouses(response);
    } catch (error) {
      throw error;
    }
  };
  useEffect(() => {
    getWarehouses(auth.data.subsidiary.subsidiary_id);
  }, []);

  const inputClass = "w-full rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-white text-sm px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors";
  const labelClass = "block text-xs font-semibold text-gray-600 dark:text-gray-400 uppercase tracking-wide mb-1";

  return (
    <>
      <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 shadow-sm p-6 mb-6">
        <h3 className="text-sm font-semibold text-gray-700 dark:text-gray-300 uppercase tracking-wide mb-4">
          DATOS OPERACIÓN
        </h3>
        <div className="border-t border-gray-200 dark:border-gray-700 mb-4"></div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          <div>
            <label className={labelClass}>TIPO DOCUMENTO:</label>
            <select
              className={inputClass}
              name="operationDocumentTypeID"
              readOnly
              value={order.operationDocumentTypeID}
            >
              {operationDocumentTypes.map((item, index) => {
                return (
                  <option key={index} value={item.id}>
                    {item.name}
                  </option>
                );
              })}
            </select>
          </div>
          <div>
            <label className={labelClass}>NÚMERO DOCUMENTO:</label>
            <input
              type="text"
              className={inputClass}
              name="operationDocumentNumber"
              placeholder="Ingrese Texto"
              readOnly
              value={order.operationDocumentNumber}
              autoComplete="off"
              maxLength={15}
            />
          </div>
          <div>
            <label className={labelClass}>FECHA DE RECEPCIÓN:</label>
            <input
              type="date"
              name="operationDate"
              className={inputClass}
              value={order.operationDate}
              readOnly
            />
          </div>
        </div>
      </div>
    </>
  );
}
